import { Button, Icon, Message } from 'semantic-ui-react';
import { renderQuestions } from '../../../../components/helpers/renderFormQuestions';
import { useState } from 'react';
import { errorInput } from '../../../../components/helpers';
import { weddingFormDocQuestions } from '../questions/weddingFormDocQuestions';

const StepReadDoc = (props) => {
  const { setStep, inputs, setInputs } = props;
  const [errorInputs, setErrorInputs] = useState({});

  const handleInputs = (event) => {
    setInputs({ ...inputs, [event.target.name]: event.target.value });
  };

  const verifyForm = () => {
    let errorInputs = {};

    let mandatoryInputs = Object.values(weddingFormDocQuestions)
      ?.map((a) => a.id)
      .filter((a) => !!a);

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs?.[input] },
      });
    });
    setErrorInputs(errorInputs);

    return Object.values(errorInputs).includes(true);
  };

  const handleContinue = () => {
    if (verifyForm()) return;
    if (
      Object.entries(inputs)
        ?.filter(([key, value]) => key.includes('doc_question'))
        .every(([key, value]) => value === 'Sí' || value === 'No aplica') &&
      Object.entries(inputs)?.filter(([key, value]) => key.includes('doc_question'))?.length ===
        weddingFormDocQuestions?.length
    ) {
      setStep('step-fill-his-data');
    } else {
      setStep('not-fulfilled');
    }
  };

  return (
    <div className="read-doc-container">
      <div className="requirements-box">
        <Message info>
          <Message.Header>
            <Icon name="info circle" /> Información Importante
          </Message.Header>
          <p>
            Diligenciar esta solicitud no asegura la celebración de la ceremonia ya que está sujeta
            a verificación, evaluación y aprobación.
          </p>
        </Message>

        <div className="document-section">
          <h3>
            <Icon name="file alternate outline" /> Documento Informativo
          </h3>
          <p className="note">
            Lee el siguiente documento informativo y una vez finalices, responde si estas de acuerdo
            con las siguientes afirmaciones:
            <br />
            <a
              href="https://drive.google.com/file/d/1mRPmrMxrHbfRukhFP0w8OJxBoul4rlWW/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon name="external alternate" /> Información Ceremonia Cristiana y Matrimonio Civil
            </a>
          </p>
        </div>

        <div className="declaration-section">
          <h3>
            <Icon name="check circle outline" /> Declaración de Compromiso
          </h3>
          <p className="note">
            Como pareja, hemos leído detenidamente el documento{' '}
            <strong>"Información Ceremonia Cristiana y Matrimonio Civil"</strong> y, con total
            conciencia y compromiso, declaramos que entendemos y aceptamos cada uno de los
            siguientes puntos requeridos por Comunidad para la celebración de nuestra ceremonia
            religiosa de matrimonio:
          </p>
        </div>

        <div className="questions-container">
          {Object.values(errorInputs).includes(true) && (
            <Message negative>
              <Message.Header>
                <Icon name="exclamation circle" /> Atención
              </Message.Header>
              <p>Todas las preguntas son obligatorias.</p>
            </Message>
          )}

          {renderQuestions({
            questions: weddingFormDocQuestions,
            inputs,
            setInputs,
            handleInputs,
            errorInputs,
            setErrorInputs,
          })}
        </div>

        <div className="button-container">
          <Button primary size="large" onClick={handleContinue}>
            <Icon name="arrow right" /> Continuar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StepReadDoc;
